// A feed row draws its entity with a component, and that component can hold a feed of its own. When a
// row's component is already being drawn by a row further up, drawing it again nests it forever and
// freezes the tab, so each row passes down the components above it and a repeat is not drawn.
export function rowAncestryWith(ancestry, dynamicComponentId) {
  return [...ancestry || [], Number(dynamicComponentId)];
}

export function isRowNestedInItself(ancestry, dynamicComponentId) {
  return (ancestry || []).includes(Number(dynamicComponentId));
}
